<template>
  <div class="painelCinza">
    <b-container fluid >
    	<b-row>
       		<b-col align-self="start">
         	 <h6><b>{{ $t('label.acesso_portal_de_compras') }}</b></h6>
       		</b-col>
    	</b-row>
		<br>
		<b-row>
       		<b-col align-self="start">
          		{{ $t(aux + '.' + 'informar_cartao_cpf') }}
       		</b-col>
      	</b-row>
		<br>
		<b-row>
       		<b-col align-self="start" fluid="lg" cols="3" class="tamanhoResponsivo">
				{{ $t('label.codigo_cartao') }}
				<b-form-group class="input-label" id="numero">
                    <b-form-input
                        type="text"
                        @keypress="metodosAuxiliares.isNumber($event)"
                        :maxlength="cartaoMax"
						 v-model="FiltroHomeLocal.codigoCartao"
                    ></b-form-input>
                </b-form-group>		
       		</b-col>
			<b-col align-self="start" fluid="lg" cols="1" class="tamanhoResponsivoDigito">
				{{ $t('label.digito') }}
				<b-form-group class="input-label">
                    <b-form-input
						v-model="FiltroHomeLocal.digitoCartao"
                        type="text"
                        @keypress="metodosAuxiliares.isNumber($event)"
                        :maxlength="digitoMax"
                    ></b-form-input>
                </b-form-group>		
       		</b-col>
			<b-col align-self="center" md="auto" cols="1" v-if="buildGVB()">
				{{ $t('label.ou') }}	
       		</b-col>   
			<b-col  fluid="lg" cols="3" class="tamanhoResponsivo" v-if="buildGVB()">
				{{ $t('label.numero_chip') }}
				<b-form-group class="input-label">
                    <b-form-input
						v-model="FiltroHomeLocal.numeroChip"
                        type="text"
                        @keypress="metodosAuxiliares.isNumber($event)"
                        :maxlength="chipMax"
                    ></b-form-input>
                </b-form-group>			
       		</b-col>			
      	</b-row>
		<br>
		<b-row>
			<b-col fluid="lg" cols="3" v-if="verifica0670()" class="tamanhoResponsivo">
				{{ $t('label.cpf') }}
				<b-form-group class="input-label">
					<the-mask class="form-control"
						:mask="'###.###.###-##'"
						v-model="FiltroHomeLocal.cpf"
                        type="text"
                        :maxlength="cpfMax"
                    ></the-mask>
                </b-form-group>			
       		</b-col>
      	</b-row>
		<b-row>
			<b-col  fluid="lg" cols="3">
				<b-button @click="this.validarLogin"  variant="primary" size="sm">{{ $t('label.acessar') }}</b-button>
       		</b-col>		
			<b-col  fluid="lg" cols="3" v-if="buildGVB()">   
				<b-button variant="primary" @click="$bvModal.show('bv-modal-example')" size="sm">{{ $t('label.como_localizar_cod') }}</b-button>	
       		</b-col>			
			<b-modal id="bv-modal-example" hide-footer hide-header>
    			<div class="d-block text-center">
     				<img src="../img/encontre_numero_cartao_chip.jpg" >
    			</div>
    			<b-button class="mt-3" block @click="$bvModal.hide('bv-modal-example')">{{ $t('label.ok') }}</b-button>
  			</b-modal>
            <b-modal id="modal-aviso-gvb" no-close-on-backdrop centered hide-footer hide-header>
                <div class="d-block text-center p-3">
                    As cargas solicitadas neste site são realizadas por meio de geração de boletos. Modalidade esta que exige compensação bancária. Dessa forma, os créditos estarão disponíveis nos validadores dos ônibus em até 3 dias úteis após a confirmação do pagamento.
                </div>
                <b-button class="mt-3" variant="success" block @click="$bvModal.hide('modal-aviso-gvb')">
                    {{ $t('label.estou_cinte') }}
                </b-button>
            </b-modal>

      	</b-row> 
		<br>
		<br>
		<b-row>
			<b-col fluid="lg" cols="10" v-if="buildGVB()">
				<div class="texto-locais-recarga-informativo">
					<p class="text-left font-weight-bold" style="font-size: 14px; font-weight: 600;">{{ $t('label.local_recarga_informativo_um') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_dois') }} <a href="https://www.cartaogv.com.br/como-chegar-ao-destino/">{{ $t('label.link_como_chegar_ao_destino') }}</a> </p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_tres') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_quatro') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_cinco') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_seis') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_sete') }}</p>
					<p class="text-left">{{ $t('label.local_recarga_informativo_oito') }} <a href="https://www.cartaogv.com.br/onde-adquirir/">{{ $t('label.link_onde_adquirir') }}</a></p> 
				</div>		
       		</b-col>
      	</b-row>
    </b-container>
    <div v-if="buildGVB()">
        <div class="cookie-footer">
            Privacidade e cookies: Esse site utiliza cookies. Ao continuar a usar este site, você concorda com seu uso. 
            Para saber mais, inclusive sobre como controlar os cookies, consulte aqui: 
            <a href="../citsbe-recarga-web/doc/PoliticaDeCookies.pdf" download>Política de cookies</a>.
        </div>
        </div>
  </div>

</template>

<script>
import {praca} from '../config.js';

import CartaoModel from '../models/CartaoModel';
import BaseMixin from '../mixins/BaseMixin';
import MetodosAuxiliares from "@/helper/MetodosAuxiliares";
import CartaoService from "@/services/CartaoService";
import LoginService from "@/services/LoginService";
import CartaoValidator from "@/models/validator/CartaoValidator";
import {mapGetters, mapState, mapActions} from 'vuex';
import {TheMask} from 'vue-the-mask';
export default {
	components: {TheMask},
	mixins: [BaseMixin],
	data() {
		return {
			cartaoService: new CartaoService(),
			loginService: new LoginService(),
			cartaoValidator: new CartaoValidator(),
			metodosAuxiliares: new MetodosAuxiliares(),

			aux: praca,

			FiltroHomeLocal: {},
			CartaoLocal: {},
			resp: {},
			cartaoMax: 14,
			digitoMax: 1,
			chipMax: 10,
			cpfMax: 14,
        	flagValidouOK: Boolean
		};
	},

	created(){
		
		this.configBreadCrumb({
			botoesAcao: {
				salvar: false,
				voltar: false
			}
		});

	},

	computed: {
		...mapGetters('SolicitacoesStore', ['FiltroSolicitacoes']),
		...mapState('SolicitacoesStore', ['FiltroSolicitacoes']),
		...mapGetters('cartaoStore', ['Cartao']),
		...mapState('cartaoStore', ['Cartao']),
        
	},

	mounted() {
        this.FiltroHomeLocal = Object.assign({}, this.FiltroHome)
		localStorage.setItem('token', '')
        this.abreModalGVB()

	},
	
	methods: {

		...mapActions('cartaoStore', ['updateStateCartao']),

        abreModalGVB() {
            if (this.aux === 'gvb' || this.aux === 'GVB') {
                this.$bvModal.show('modal-aviso-gvb');
                return true;
            }
        },


        buildGVB() {
            if (this.aux === 'gvb' || this.aux === 'GVB') {
                return true;
            } else {
                return false;
            }
        },


        buildFLN() {
            if (this.aux == 'fln' || this.aux == 'FLN' || this.aux == 'fle' || this.aux == 'FLE') {
                return true
            } else {
                return false
            }
        },

        buildSCA() {
            if (this.aux == 'sca' || this.aux == 'SCA') {
                return true
            } else {
                return false
            }
        },

        buildTHE() {
            if (this.aux == 'the' || this.aux == 'THE') {
                return true
            } else {
                return false
            }
        },


		async validarLogin() {

            if (this.buildTHE() && this.verifica0360()) {
                var objParam = {
                    titulo: this.$t("label.aviso"),
                    descricao: this.$t("label.acesso_negado_0360")
                };
                this.criaModalMensagem(objParam, null, null);   
                return
            }

			this.FiltroHomeLocal.cpf = this.FiltroHomeLocal.cpf == "" ?  "0" : this.FiltroHomeLocal.cpf;
			let cartao = new CartaoModel(this.FiltroHomeLocal.codigoCartao, this.FiltroHomeLocal.numeroChip, this.FiltroHomeLocal.digitoCartao, this.FiltroHomeLocal.cpf);
			let tipoCartao = this.cartaoValidator.TipoCartao(cartao);
			await this.loginService.efetuaLogin().then(
				
				response => {
					if (!(response.status === undefined)) {
						var objParam = {
							titulo: this.$t("label.aviso"),
							descricao: this.$t("label.falha_na_autenticacao")
						};
						this.criaModalMensagem(objParam, null, null); 						
					}
					localStorage.setItem('token', JSON.stringify(response.access_token))
					switch (tipoCartao) {
						case "NumeroAntigo":
							this.LoginNumeroAntigo(cartao);
						break;
						case "ComDigito":
							this.LoginComDigito(cartao);
						break;
					}
				},
				error => {
					if(error.response.status == 400 ){
						this.criaModalMensagem(objParam, null, null);
					} else if (error.response.status == 401) {
						this.criaModalMensagem(objParam, null, null);
					} else {
						throw new Error("ERRO");
					}
				}
			);
		},
		
		async redirectSolicitacoes() {
			this.$router.push({ name: "Solicitacoes" });
		},

		async LoginNumeroAntigo(cartao) {
			var validacaoOk = this.cartaoValidator.ValidarNumeroAntigo(cartao);
			if (validacaoOk){
				if(await this.loginByNumeroChip(cartao.numeroChip, cartao.cpf)){
					this.redirectSolicitacoes();
				}
			} else
				this.showModalPreenchaDados();
		},

		async LoginComDigito(cartao) {
			var validacaoOk = this.cartaoValidator.ValidarNumeroNovo(cartao)
			if (validacaoOk){
				if (await this.loginByCodCartao(cartao.codigoCartao, cartao.digitoCartao, cartao.cpf)) {
					this.redirectSolicitacoes();
				} 
			} else {
				this.showModalPreenchaDados();
			}
		},

		async loginByNumeroChip(numeroChip, cpf) {
			var retorno = false;
			cpf = this.metodosAuxiliares.formatarCpf(cpf);

			await this.cartaoService.getUserByNumeroChip(numeroChip, cpf).then(
				response => {
					this.updateStateCartao(response);
					retorno = true;
				},
				error => {
					if (!(error.response === undefined) &&
						!(error.response.data === undefined) &&
						(this.cartaoValidator.ConferirVazioOuNulo(error.response.data))) {
						var objParam = {
						titulo: this.$t("label.aviso"),
						descricao: this.$t("label.preencha_dados")
					};
					this.criaModalMensagem(objParam, null, null); 
					} else if (error.response.status === 400) {
						var objParam = {
						titulo: error.response.data.title, 
						descricao: error.response.data.detail 
						};
						this.criaModalMensagem(objParam, null, null);
					} else {
						var objParam = {
						titulo: this.$t("label.aviso"),
						descricao: this.$t("label.preencha_dados")
					};
					this.criaModalMensagem(objParam, null, null); 
					}
					retorno = false;				
				}
			);
			return retorno;
		},

		async loginByCodCartao(codigoCartao, digitoCartao, cpf) {
			var retorno = false;

			cpf = this.metodosAuxiliares.formatarCpf(cpf);
			await this.cartaoService.getUserByCodCartao(codigoCartao, digitoCartao, cpf).then(
				response => {	
					this.updateStateCartao(response);
					retorno = true;
				},
				error => {
					if (!(error.response === undefined) &&
						!(error.response.data === undefined) &&
						(this.cartaoValidator.ConferirVazioOuNulo(error.response.data))) {
						var objParam = {
						titulo: this.$t("label.aviso"),
						descricao: this.$t("label.preencha_dados")
					};
					this.criaModalMensagem(objParam, null, null); 
					} else if (error.response.status === 400) {
						var objParam = {
						titulo: error.response.data.title, 
						descricao: error.response.data.detail 
						};
						this.criaModalMensagem(objParam, null, null); 
				  } else {
						var objParam = {
						titulo: this.$t("label.aviso"),
						descricao: this.$t("label.preencha_dados")
						};
						this.criaModalMensagem(objParam, null, null); 
					}
					retorno = false;				
				}
			);
			return retorno;
		},	

        verifica0360() {

			var aux = this.FiltroHomeLocal.codigoCartao
			aux = aux.substring(0,4)		

			if (aux.includes('0360')) {
				this.FiltroHomeLocal.cpf = ''
				return true
			} else {
				return false
			}
        },

		verifica0670() {
			var aux = ''
			var lenghtAux = ''
			var lenghtMax = ''

			if(this.FiltroHomeLocal.codigoCartao == null | this.FiltroHomeLocal.codigoCartao == undefined || this.FiltroHomeLocal.codigoCartao == "") {
				aux = '123456'
			} else {
				aux = this.FiltroHomeLocal.codigoCartao
			}

			lenghtAux  = aux.length
			lenghtMax = aux.substring(0,4)		

			if (lenghtMax.includes('0670')) {
				this.FiltroHomeLocal.cpf = ''
				return false
			} else {
				return true
			}
		},

		showModalPreenchaDados() {
			var objParam = {
				titulo: this.$t("label.aviso"),
				descricao: this.$t("label.preencha_dados")
			};
			this.criaModalMensagem(objParam, null, null);   
			this.flagValidouOK = false;
		},
	}
}
</script>
<style scoped>
.cookie-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #99eb96;
  text-align: center;
  font-size: 14px;
  padding: 10px;
  border-top: 1px solid #ddd;
  z-index: 1050;
}
.cookie-footer a {
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
}
</style>


